export class WebViewMessageCommandModel {
    viewCommand: string;
    id: string;
    ids: string[];
    customField1: string;
    customField2: string;    
    searchParamWrap: DTISearchParamWrap;
}

export class DTISearchParamWrap{
    searchParamVehicles: SearchParamVehicleTab;
    searchParamSales: SearchParamSaleTab;
    searchParamTasks: SearchParamTaskViewer;
}

export class SearchParamVehicleTab{
    searchText: string;
    dealershipId: string;
    vehicleSoldState: string;
}

export class SearchParamSaleTab {
    searchText: string;
    dealershipId: string;
    saleStatus: string;
    startDate: string;
    endDate: string;
}

export class SearchParamTaskViewer{
    searchText: string;
    taskIds: string[];
    taskStatus: string;
}